// @flow

import _ from 'lodash';

import ApiObject from '../ApiObject';
import DateUtils from '../../utils/DateUtils';
import ArrayUtils from '../../utils/ArrayUtils';

export default class RestaurantsGroup extends ApiObject {

  id: string;

  restaurantsIds: Array<String> = [];

  children: Array<RestaurantsGroup> = [];

  level: number;

  /**
   *
   * @type string
   */
  creatorRestaurantsGroupId: ?string = null;

  /**
   *
   */
  parentId: string;

  childrenIds: Array<String>;

  creationDate: ?Moment = null;

  postJsonAssignation(data: Object) {
    super.postJsonAssignation(data);

    this.children = [];
    _.each(data.children, (dataChildren: Object) => {
      const restaurantsGroup: RestaurantsGroup = new RestaurantsGroup();
      restaurantsGroup.fromJson(dataChildren);
      this.children.push(restaurantsGroup);
    });

    this.creationDate = DateUtils.fromMsTimestamp(data.creationDate);
  }

  toJSON() {
    const json = super.toJSON();

    if (!_.isNull(this.creationDate)) {
      json.creationDate = this.creationDate.valueOf();
    }

    return json;
  }

  haveChilds(): boolean {
    return !_.isEmpty(this.children);
  }

  haveMultipleRestaurants(): boolean {
    return !_.isEmpty(this.restaurantsId);
  }

  findWithId(id: string) {
    let result = null;
    if (this.id === id) {
      return this;
    }

    _.each(this.children, (children: RestaurantsGroup) => {
      const childrenRes = children.findWithId(id);
      if (!_.isNull(childrenRes)) {
        result = childrenRes;
        return false; // quit loop.
      }
    });

    return result;
  }

  addRestaurantId(restaurantId: string) {
    // handle duplicate.
    const exists = ArrayUtils.exists(this.restaurantsIds, (id: string) => {
      return id === restaurantId;
    });
    if (!exists) {
      this.restaurantsIds.push(restaurantId);
    }
  }

  removeRestaurantId(restaurantId: string) {
    this.restaurantsIds = ArrayUtils.removeObject(this.restaurantsIds, (id: string) => {
      return restaurantId === id;
    });

    _.each(this.children, (child: RestaurantsGroup) => {
      child.removeRestaurantId(restaurantId);
    });
  }

  updateRestaurantsGroup(restaurantsGroupToUpdate: RestaurantsGroup) {
    const objectExists = ArrayUtils.exists(this.children, (child: RestaurantsGroup) => {
      return child.id === restaurantsGroupToUpdate.id;
    });

    if (!_.isNull(objectExists)) {
      this.children = ArrayUtils.updateObject(this.children, restaurantsGroupToUpdate, { id: restaurantsGroupToUpdate.id });
    } else {
      _.each(this.children, (child: RestaurantsGroup) => {
        child.updateRestaurantsGroup(restaurantsGroupToUpdate);
      });
    }
  }

  //
  //
  //

  getRecursiveChildren() {
    let result = [].concat(this.children);

    _.each(this.children, (child: RestaurantsGroup) => {
      result = result.concat(child.getRecursiveChildren());
    });

    return result;
  }

  getRecursiveChildrenIds() {
    const childs = this.getRecursiveChildren();
    const ids = [];

    _.each(childs, (restaurantsGroup: RestaurantsGroup) => {
      ids.push(restaurantsGroup.id);
    });

    return ids;
  }

  getRecursiveParentsWithRoot(root: RestaurantsGroup, current: RestaurantsGroup) {
    let res = [].concat(current);

    const parent = root.findWithId(current.parentId);

    if (!_.isNull(parent)) {
      res = res.concat(this.getRecursiveParentsWithRoot(root, parent));
      return res;
    }

    return res;
  }

  getRecursiveParentsIdsWithRoot(root: RestaurantsGroup) {
    const parents = this.getRecursiveParentsWithRoot(root, this);
    const ids = [];

    _.each(parents, (restaurantsGroup: RestaurantsGroup) => {
      ids.push(restaurantsGroup.id);
    });

    return ids;
  }

  // TODO: to be tested
  haveRestaurantWithId(restaurantIdToFind: string) {
    let found = false;

    _.each(this.restaurantsIds, (restaurantId: string) => {
      if (restaurantIdToFind === restaurantId) {
        found = true;
        return false; // quit loop
      }
    });

    if (!found) {
      _.each(this.children, (children: RestaurantsGroup) => {
        if (children.haveRestaurantWithId(restaurantIdToFind)) {
          found = true;
          return false; // quit loop
        }
      });
    }

    return found;
  }

  /**
   * Return true if the restaurant group contains only one restaurant, with the given id.
   */
  isOnlyForTheRestaurantWithId(restaurantIdToFind: string) {
    return this.haveRestaurantWithId(restaurantIdToFind)
    && this.restaurantsIds.length === 1
    && this.children.length === 0;
  }

  updateRestaurantsGroups(restaurantsGroupToUpdate: RestaurantsGroup) {
    const tmpChildren = [];

    _.each(this.children, (restaurantsGroup: RestaurantsGroup) => {
      if (restaurantsGroup.id === restaurantsGroupToUpdate.id) {
        tmpChildren.push(restaurantsGroupToUpdate);
      } else {
        tmpChildren.push(restaurantsGroup.updateRestaurantsGroups(restaurantsGroupToUpdate));
      }
    });

    this.children = tmpChildren;
  }

  getAllRestaurantsGroupsIdsWithRestaurantId(restaurantId: string): Array<RestaurantsGroup> {
    const groups = this.getAllRestaurantsGroupsWithRestaurantId(restaurantId);

    const ids = [];
    _.each(groups, (restaurantsGroup: RestaurantsGroup) => {
      ids.push(restaurantsGroup.id);
    });
    return ids;
  }

  getAllRestaurantsGroupsWithRestaurantId(restaurantId: string): Array<RestaurantsGroup> {
    const res = RestaurantsGroup.getAllRestaurantsGroupsWithRestaurantIdOnRestaurantsGroup(this, restaurantId);

    if (this.haveRestaurantWithId(restaurantId)) {
      res.push(this);
    }

    return res;
  }

  static getAllRestaurantsGroupsWithRestaurantIdOnRestaurantsGroup(currentRestaurantsGroup: RestaurantsGroup, restaurantId: string) {
    let res = [];

    _.each(currentRestaurantsGroup.children, (restaurantsGroup: RestaurantsGroup) => {
      if (restaurantsGroup.haveRestaurantWithId(restaurantId)) {
        res.push(restaurantsGroup);
        res = res.concat(RestaurantsGroup.getAllRestaurantsGroupsWithRestaurantIdOnRestaurantsGroup(restaurantsGroup, restaurantId));
      }
    });

    return res;
  }
}
